import configure from "./configure";

const { standardHeaders, axios } = configure;

export const loadTopDoctors = () => {
  return axios.get("top-doctors", standardHeaders);
};
